/** Date helpers in the business timezone (Africa/Harare, UTC+2, no daylight saving). */

const OFFSET = '+02:00';

/** Today's date in Harare as yyyy-mm-dd. */
export function todayLocal(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Harare' }).format(new Date());
}

export function addDays(date: string, days: number): string {
  const d = new Date(`${date}T12:00:00${OFFSET}`);
  d.setUTCDate(d.getUTCDate() + days);
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Harare' }).format(d);
}

export function startOfDayIso(date: string): string {
  return new Date(`${date}T00:00:00.000${OFFSET}`).toISOString();
}
export function endOfDayIso(date: string): string {
  return new Date(`${date}T23:59:59.999${OFFSET}`).toISOString();
}

export function startOfMonth(date: string): string {
  return `${date.slice(0, 7)}-01`;
}

export type RangeKey = 'today' | 'yesterday' | '7d' | '30d' | 'month' | 'custom';

export function rangeFor(key: RangeKey, custom?: { from: string; to: string }): { from: string; to: string } {
  const t = todayLocal();
  switch (key) {
    case 'today':
      return { from: t, to: t };
    case 'yesterday':
      return { from: addDays(t, -1), to: addDays(t, -1) };
    case '7d':
      return { from: addDays(t, -6), to: t };
    case '30d':
      return { from: addDays(t, -29), to: t };
    case 'month':
      return { from: startOfMonth(t), to: t };
    case 'custom':
      return custom ?? { from: t, to: t };
  }
}

export const RANGE_OPTIONS: { value: RangeKey; label: string }[] = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: 'month', label: 'This month' },
  { value: 'custom', label: 'Choose dates' },
];
